<template>
    <div style="position: relative; height: 100vh;width: 100vw;overflow-y: auto;overflow-x: hidden;">
        <!-- 轮播图 -->
        <!-- <div class="one-card" style=" border-radius: 0; position: relative; width: 100vw; height:800px;margin: 0;">
            <video src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/8%E6%9C%887%E6%97%A5.mp4" autoplay muted
                loop style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                preload="auto">
            </video>
            <div class="textara">
                <div class="text-cons">新闻详情</div>
                <div class="text-fonts">了解最新行业资讯，技术应用和公司动态</div>
            </div>
        </div> -->
        <!-- 内容 -->
        <div class="content" style="text-align: center; margin-top: 80px;">
            <div style="display: flex; align-items: center; justify-content: end;width: 92%; cursor: pointer;">
                <img src="../assets/retu.png" alt="" @click="jumpToActiveIndexOne" style="width: 150px;height: 60px;">
            </div>
            <div style="font-size: 34px; font-weight: 600;">{{ content.title }}</div>
            <img style="width: 50%; height: 450px; object-fit: contain; margin-top: 30px;" :src="content.pic" mode="" />
            <div class="jianjie">
                <div>发表于 {{ toTime(content.createtime) }}</div>
                <div>新闻简介</div>
            </div>
            <div id="content" v-html="removeSpecificHtmlTags(content.content)"></div>
        </div>
        <!-- 底部 -->
        <div style="position: relative; height: 100vh;">
            <div class="card-imgs" :class="activeIndex == 2 ? 'animated-image' : ''">
                <video
                    src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
                    autoplay muted loop style="width: 100%; height: 100vh;  object-fit: cover;" preload="auto">
                </video>
                <div class="gradient-con">
                    <div class="gradient-text ">链上生态互融 共享数字未来</div>
                    <div class="gradient-p">智慧谷-您的企业数改服务商</div>
                </div>
            </div>
            <div class="footer" :class="activeIndex == 2 ? 'animated-image' : ''">
                <div class="footer_top">
                    <!-- 左 -->
                    <div class="footerTopLeft">
                        <!-- 1 -->
                        <div class="LeftCon" style="cursor: pointer;">
                            <h4 @click="jumps(0)">走进智慧谷</h4>
                            <p @click="jumps(1)">集团介绍</p>
                            <p @click="jumps(5)">发展历程</p>
                            <p @click="jumps(7)">企业荣誉</p>
                        </div>
                        <div class="LeftCon" style="cursor: pointer;">
                            <h4 @click="jumphx(0)">核心业务</h4>
                            <p @click="jumphx(5)">CHAIN企业链改服务</p>
                            <p @click="jumphx(8)">企链通DAPP数商平台</p>
                            <p @click="jumphx(11)">智慧谷AI名片</p>
                        </div>
                        <div class="LeftCon" style="cursor: pointer;">
                            <h4 @click="jumpcj(0)">应用场景</h4>
                            <p @click="jumpcj(2)">数字支付</p>
                            <p @click="jumpcj(3)">数字商城</p>
                            <p @click="jumpcj(19)">数字三农</p>
                        </div>
                        <div class="LeftCon" style="cursor: pointer;">
                            <h4 @click="jumpgh(0)">合作规划</h4>
                            <p @click="jumpgh(1)">合作流程</p>
                            <p @click="jumpgh(2)">合作收益</p>
                            <p @click="jumpgh(4)">全球战略</p>
                        </div>
                    </div>
                    <div class="footerTopRight">
                        <div class="RightCon">
                            <img src="../assets/tel.png" mode=""></img>
                            <p>电话：400-8537-168</p>
                        </div>
                        <div class="RightCon">
                            <img src="../assets/web.png" mode=""></img>
                            <p style="cursor: pointer;">网址：www.gjzhg.com</p>
                        </div>
                        <div class="RightCon">
                            <img src="../assets/email.png" mode=""></img>
                            <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
                        </div>
                        <div class="RightCon">
                            <img src="../assets/dz.png" mode=""></img>
                            <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
                        </div>
                        <div class="code">
                            <div
                                style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                <img src="../assets/gzh.jpg" alt=""
                                    style="width: 90px;height: 90px;border-radius: 10px;">
                                <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                            </div>
                            <div
                                style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                <img src="../assets/kf.png" alt=""
                                    style="width: 90px;height: 90px;border-radius: 10px;">
                                <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer_botm">
                    <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
                    <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                    <p style="text-indent:1em;">闽ICP备16005520号-1</p>
                    <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                    <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
                    <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                    <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
                    <p style="text-indent:1em;">|</p>
                    <p style="text-indent:1em;"> Powered by CloudDream </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: "FullPage",
    data() {
        return {
            newsData: null,
            content: '',
            loinshow: false,
            activeIndex: 0,
            newsDatas: [],//循环新闻
            // 核心业务
            pageIndex: 0,
            businessActive: 0,
            timeoutId: null,    // 用于清除 15 秒超时的计时器
            intervalId: null,   // 用于清除自动切换 tab 的定时器
            // 导航栏
            topTabActive: 0,

            pages: 1,
        };
    },
    mounted() {
        // 
        this.content = JSON.parse(localStorage.getItem('selectedNews'))


    },
    watch: {
    },
    methods: {
        removeSpecificHtmlTags(inputString) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(inputString, 'text/html');

            function cleanNode(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    const tagName = node.tagName.toLowerCase();

                    // 检查是否是空标签或占位符标签
                    if (
                        (tagName === 'p' || tagName === 'div' || tagName === 'span') &&
                        !node.textContent.trim() &&
                        !node.querySelector('img')
                    ) {
                        node.remove();
                        return;
                    }
                    // 递归清理子节点
                    Array.from(node.childNodes).forEach(cleanNode);
                }
            }

            Array.from(doc.body.childNodes).forEach(cleanNode);

            return doc.body.innerHTML;
        },
        // 5个
        jumps(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
        },

        jumphx(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
        },

        jumpcj(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },

        jumpgh(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
        },
        // 返回按钮
        jumpToActiveIndexOne() {
            this.$router.replace({
                path: '/news',
                query: { num: 1 }
            });
        },
        addStyleToImages(content) {
            // 在这里实现对图片样式的处理逻辑
            return content;
        },
        toTime(timestamp) {
            // 时间格式化逻辑
            const date = new Date(timestamp * 1000);
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        nextCardPage() {
            if (this.pages <= 7) {
                let a = this.pages++
                this.getNewsList(a)
            }
        },
        prevCardPage() {
            if (this.pages > 1) {
                let a = this.pages--
                this.getNewsList(a)
            }

        },
        toTime(timestamp) {
            var date = new Date(timestamp * 1000);
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() + ' ';
            return Y + M + D;
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

#content {
    margin-top: 50px;
    border-top: 1px solid #dadada;
    width: 80%;
    margin-left: 10%;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-indent: 2em;
    line-height: 2;
}

#content p {
    margin-top: -20px;
}

.jianjie {
    margin-top: 50px;
    display: flex;
    width: 70%;
    margin-left: 15%;
    align-items: center;
    justify-content: space-between;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

.RightCon p {
    color: #989898;
    cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}



.footerMidd {
    width: 70%;
    height: 75%;
    border-bottom: 1px solid #cacaca;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.codes {
    width: 23%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.codes img {
    width: 100%;
    height: 100%;
}

.code h5 {
    margin-top: 10px;
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;
}

.card-imgs {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    object-fit: fill;
    position: absolute;

}

.vjs-custom-skin {
    width: 100%;
    height: 100%;
}

.video-js {
    width: 100% !important;
    height: 100% !important;
    min-height: 300px;
}

.video-js video {
    object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
    .card-imgs {
        max-width: 100%;
        margin-right: 0;
    }

    .card-imgs .video-js {
        min-height: 250px;
    }
}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/message.vue